import React from 'react';
import { CheckCircle2, Circle, Smartphone, Globe, Phone } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { UTT_LINKS } from './uttSteps';

const LinkBtn = ({ href, icon: Icon, label, testid }) => (
  <a href={href} target={href.startsWith('tel:') ? undefined : '_blank'} rel="noreferrer" data-testid={testid}
    className="inline-flex items-center gap-1.5 rounded-full border border-primary/30 px-3 py-1.5 text-xs font-medium text-primary transition-colors duration-200 hover:bg-primary/10">
    <Icon className="h-3.5 w-3.5" />{label}
  </a>
);

export const UttLinks = () => {
  const { t } = useLanguage();
  return (
    <div className="flex flex-wrap gap-2" data-testid="utt-links">
      <LinkBtn href={UTT_LINKS.android} icon={Smartphone} label="Google Play" testid="utt-link-android" />
      <LinkBtn href={UTT_LINKS.ios} icon={Smartphone} label="App Store" testid="utt-link-ios" />
      <LinkBtn href={UTT_LINKS.portal} icon={Globe} label={t('Web portal', 'Tovuti ya wawekezaji')} testid="utt-link-portal" />
      <LinkBtn href={UTT_LINKS.ussd} icon={Phone} label="*150*82#" testid="utt-link-ussd" />
      <LinkBtn href={UTT_LINKS.helpline} icon={Phone} label={t('Helpline 0800 112 020', 'Msaada 0800 112 020')} testid="utt-link-helpline" />
    </div>
  );
};

export const StepGuide = ({ steps, done, onToggle }) => {
  const { language } = useLanguage();
  const doneSet = new Set(done);
  return (
    <ol className="space-y-2" data-testid="utt-step-guide">
      {steps.map((s, i) => {
        const on = doneSet.has(s.id);
        return (
          <li key={s.id} className={`rounded-2xl border p-3 transition-colors duration-200 ${on ? 'border-primary/30 bg-primary/5' : 'border-border/60'}`}>
            <div className="flex items-start gap-3">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-muted text-xs font-semibold">{i + 1}</span>
              <p className={`flex-1 text-sm ${on ? 'text-muted-foreground line-through decoration-primary/40' : ''}`}>{language === 'sw' ? s.sw : s.en}</p>
              <button type="button" onClick={() => onToggle(s.id, !on)} data-testid={`utt-step-${s.id}`} aria-pressed={on}
                className={`flex shrink-0 items-center gap-1 rounded-full px-2.5 py-1 text-xs font-medium transition-colors duration-200 ${on ? 'bg-primary text-primary-foreground' : 'bg-muted hover:bg-primary/10'}`}>
                {on ? <CheckCircle2 className="h-3.5 w-3.5" /> : <Circle className="h-3.5 w-3.5" />}
                {language === 'sw' ? 'Nimemaliza' : 'Done'}
              </button>
            </div>
            {s.links && <div className="mt-2 pl-9"><UttLinks /></div>}
          </li>
        );
      })}
    </ol>
  );
};
